import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { registerCard } from '@chess/api-dashboard';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { StageErrorsAggregator } from '@chess/api-insights';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import '@chess/api-insights/charts.css';
import { EndingErrorsCard, TITLE } from './EndingErrorsCard.tsx';

// Ending card "Ending errors": blunders, misses and winning positions lost.
// On `ending.more` (order 10): the Ending screen's "More" section,
// under the stage's top cards; not on Home, which shows the top cards only.
// Links carry the last 30 days (`libraryLink`), so a bar's count is the
// filtered library's.
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  // The stage's errors, shared with the other ending cards: the service runs it once.
  const aggregator = new StageErrorsAggregator('endgame');
  registerAggregator(getApi, aggregator);
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path)), [navigate]);
    // Never hidden while the store loads: the card shows skeletons for its values.
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <EndingErrorsCard loading />;
    return result ? <EndingErrorsCard endgame={result} link={link} /> : null;
  };
  registerCard(app, 'home.section.ending', Card, { order: 5, title: TITLE });
}
